<ng-select [items]="categories" bindLabel="category_Name" bindValue="id" [virtualScroll]="true"
    placeholder="{{_placeholder}}" [(ngModel)]="categoryId" (ngModelChange)="onChanged()" [selectOnTab]="true">
</ng-select>
